import { render, staticRenderFns } from "./salary-selfdefined.vue?vue&type=template&id=64a62bea&scoped=true&"
import script from "./salary-selfdefined.vue?vue&type=script&lang=js&"
export * from "./salary-selfdefined.vue?vue&type=script&lang=js&"
import style0 from "./salary-selfdefined.vue?vue&type=style&index=0&id=64a62bea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a62bea",
  null
  
)

export default component.exports